import React from 'react';
import { useIntl } from 'react-intl';
import Spinner from '@/components/UI/Spinner';

type GameProvidersHeaderProps = {
  header: string;
  subheader?: string;
  loading: boolean;
  count: number;
};

function GameProvidersHeader({
  header,
  subheader,
  count,
  loading,
}: GameProvidersHeaderProps): JSX.Element {
  const intl = useIntl();

  return (
    <div className="max-w-container px-4 lg:px-8 mx-auto flex justify-between items-center">
      <div>
        <h1 className="font-bold text-3xl mb-1">{header}</h1>
        {subheader && <p className="text-gray-400 font-bold text-lg">{subheader}</p>}
      </div>
      <div className="text-xl font-bold">
        {' '}
        {loading ? <Spinner dark height={14} width={14} borderwidth={3} /> : count}
        &nbsp;{intl.formatMessage({ id: 'games.nav.providers' })}
      </div>
    </div>
  );
}

export default GameProvidersHeader;
